import React from "react";

/**
 * Phone frame for the real EMIBOOK app screenshots (9:19.5 portrait).
 * Screenshots are shown uncropped-at-the-top so the app's own header stays
 * readable instead of being centre-cropped into nonsense.
 */
export default function DeviceFrame({ src, alt, style, className = "", children }) {
  return (
    <div className={`eb-device ${className}`} style={style}>
      <div className="eb-device-screen">
        {src ? <img src={src} alt={alt} loading="lazy" /> : null}
        {children}
      </div>
    </div>
  );
}
